class Origin {}

const origin = new Origin();

const useUserOrigin = () => {
  return origin;
};

export default useUserOrigin;
